import styled from 'styled-components'
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

export const HeaderDescription = styled.h2`
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: 1rem;
    letter-spacing: 0.15px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 30px */
`

export const TitleContainer = styled.div`
    padding: 1rem;
    border-radius: var(--3, 24px);
    background: var(--background-success, #F1F7FF);
    justify-content: space-between;
    gap: 4rem;
    
    @media only screen and (max-width: 600px) {
        font-size: 1rem;
        font-weight: 600;
        letter-spacing: 0.15px;
        flex-direction: column;
        gap: 1.5rem;
    }
`

export const ConfirmedJobBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const LeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 50%;
    width: 100%;
    gap: 0.625rem;
    align-self: center;
    @media only screen and (max-width: 600px) {
        max-width: 100%;
    }
`
export const RightContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 50%;
    width: 100%;
    gap: 0.625rem;
    @media only screen and (max-width: 600px) {
        max-width: 100%;
    }
`

export const TopContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 4rem;

    @media only screen and (max-width: 600px) {
        font-size: 1rem;
        font-weight: 600;
        letter-spacing: 0.15px;
        flex-direction: column;
        gap: 1.5rem;
    }
`

export const BottomContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.625rem;
`

export const Link = styled.a`
    color: var(--info-main, #0288D1);

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 166%;
    letter-spacing: 0.4px;`

export const Subtitle = styled.div`
    font-size: var(--typography-body2-size);

    line-height: 1.3;
    color: #000;
    font-weight: 400;
    opacity: 60%;
`

export const ValueBox = styled.h5`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-feature-settings: 'clig' off, 'liga' off;
    
    font-size: var(--typography-h5-size);
    font-style: normal;
    font-weight: 600;
    line-height: 133.4%; /* 32.016px */
    margin: unset;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    @media only screen and (max-width: 600px) {
        font-size: var(--font-size-mid);
    }
`

export const Value = styled.h4`
    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: var(--typography-h5-size);
    font-style: normal;
    font-weight: 600;
    line-height: 123.5%;
    letter-spacing: 0.25px;
    margin: unset;
    //width: 100%;
    @media only screen and (max-width: 600px) {
        font-size: var(--typography-h6-size);
    }
`

export const RateContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    max-width: 50%;
    width: 100%;
    @media only screen and (max-width: 600px) {
        max-width: 100%;
        flex-direction: row;
    }
`

export const HourlyRate = styled(Value)`
    font-size: var(--typography-h4-size);
    @media only screen and (max-width: 600px) {
        font-size: var(--typography-h6-size);
    }
`

export const DateTimeDescription = styled.div`
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: var(--input-helper-size);
    line-height: 166%; /* 19.92px */
    letter-spacing: 0.4px;
    font-style: normal;
    font-weight: 400;
`

export const DescriptionContainer = styled.div`
    display: flex;
    padding: var(--3, 24px);
    flex-direction: column;
    gap: 27px;
    border-radius: var(--3, 24px);
    background: var(--background-info, #F7F7F7);
    margin: 1rem 0;

    @media only screen and (max-width: 400px) {
        font-size: 1rem;
        font-weight: 600;
        letter-spacing: 0.15px;
        flex-direction: column;
    }
`

export const UserContainer = styled.div`
    display: flex;
    padding: var(--3, 24px);
    flex-direction: column;
    gap: 27px;
    border-radius: var(--3, 24px);
    background: var(--common-white-main, #fff);
    border: 1px solid var(--primary-blue, #0B4598);
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    margin: 1rem 0;

    @media only screen and (max-width: 400px) {
        font-size: 1rem;
        font-weight: 600;
        letter-spacing: 0.15px;
        flex-direction: column;
    }
`

export const ConfirmedShiftIcon = styled(EventAvailableIcon)`
    color: white;
    height: 1rem;
    width: 1rem;
    padding-right: 0.25rem;
`

export const ButtonBox = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    align-self: stretch;
`

export const ChangeShiftTimeBox = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    align-self: stretch;
    width: fit-content;
    flex-direction: row;

    @media only screen and (max-width: 600px) {
        flex-direction: column;
    }
`

export const ShiftDateIcon = styled(DateRangeOutlinedIcon)`
        height: 1rem;
        width: 1rem;
        padding-right: 0.25rem;
`

export const ChangeShiftTimesBtn = styled(StyledButton)`
    padding: 0.5rem 1rem !important;
`

export const UnderlinedLink = styled.a`
    min-width: fit-content;
    text-decoration: underline;
`

export const CallBtn = styled(StyledButton)`
    padding: 0.5rem 1rem !important;
    font-size: 0.875rem !important;
    width: unset !important;
    max-width: 50%;
`

export const MessageBtn = styled(StyledButton)`
    padding: 0.5rem 1rem !important;
    font-size: 0.875rem !important;
    width: unset !important;
`

export const BookTempBtn = styled(StyledButton)`
    max-width: 24rem;
`